import { http } from '../http';
import { unwrapSuccess } from '../helpers';

export async function listPlans(page, size) {
    const res = await http.get('/plans', {
        params: { page, size },
    });
    return unwrapSuccess(res);
}

export async function detailPlan(id) {
    const res = await http.get(`/plans/${id}`);
    return unwrapSuccess(res);
}

export async function createPlan(payload) {
    const res = await http.post('/plans', payload);
    return unwrapSuccess(res);
}

export async function updatePlan(id, payload) {
    const res = await http.put(`/plans/${id}`, payload);
    return unwrapSuccess(res);
}

export async function deletePlan(id) {
    return http.delete(`/plans/${id}`);
}

export async function sortPlans(payload) {
    return http.post(`/plans/sort`, payload);
}
